export const addMessage = message => ({
  type: "ADD_MESSAGE",
  message
});

export const removerMessage = message => ({
  type: "REMOVER_MESAJE",
  message
});
